import { useCanvasStore } from '$viewer/store/canvasStore';
import { getActiveViewerOverlayEngine } from './viewerOverlayEngineRef';

/**
 * 활성 viewer 엔진이 없을 때(Provider 밖·초기 마운트 전)의 dirty 세대.
 * 엔진이 있으면 엔진의 세대를 쓰며, 이 값은 건드리지 않습니다.
 */
let fallbackDirtyGeneration = 0;

export const getOverlayDirtyGeneration = (): number =>
  getActiveViewerOverlayEngine()?.getDirtyGeneration() ??
  fallbackDirtyGeneration;

export const markOverlayDirty = (): void => {
  const engine = getActiveViewerOverlayEngine();
  if (engine) {
    engine.markDirty();
    return;
  }
  fallbackDirtyGeneration += 1;
};

/**
 * 오버레이 갱신을 위해 캔버스 프레임을 1회 요청한다.
 *
 * 오버레이 도장은 R3F 프레임에 결합돼 있으므로(`OverlayFrameDriver`),
 * `frameloop="demand"` 에서는 캔버스가 렌더되지 않으면 오버레이도 갱신되지 않는다.
 * 레이어 등록/해제/갱신처럼 R3F 가 알 수 없는 dirty 소스는 여기서 직접 무효화한다.
 * 활성 viewer 엔진이 있으면 그 엔진의 세대와 바인딩에 위임한다.
 */
export const invalidateCanvas = (): void => {
  markOverlayDirty();
  useCanvasStore.getState().canvasState?.invalidate();
};
